import React from "react";
import { useSearchParams } from "react-router-dom";
import { userTableParams } from "../features/admin/users/DesktopUserListingPage";

export const ClinicUsersContext = React.createContext();

export default function ClinicUsers({ children, data, loading, error }) {
 // Extract data from the new paginated response structure
  const users = data?.users || [];
  const totalCount = data?.total || 0;
  const totalPages = data?.pages || 0;

 


  const values = {
    getTableData: () => users,
    getLoading: () => loading,
    getError: () => error,
    getPagination: () => ({
      pages: totalPages,
      total: totalCount
    })
  };

  return (
    <ClinicUsersContext.Provider value={values}>
      {children}
    </ClinicUsersContext.Provider>
  );
}
